import { useDashboardStore, TAB_CONFIG } from '@/stores/dashboardStore';
import { useDashboard } from '@/hooks/useDashboard';

export default function Tabs() {
  const { currentTab, tabData } = useDashboardStore();
  const { switchTab } = useDashboard();

  const countAbnormal = (tabId: string): number => {
    const tab = tabData[tabId];
    if (!tab?.abnormal) return 0;
    const { data, total, totals } = tab.abnormal;
    // 优先使用后端返回的 total/totals（全部数据口径），避免分页加载过程中数字不断增长
    if (totals && typeof totals === 'object') {
      return Object.values(totals).reduce(
        (sum: number, v) => sum + (typeof v === 'number' ? v : 0),
        0,
      );
    }
    if (typeof total === 'number') return total;
    if (Array.isArray(data)) return data.length;
    if (typeof data === 'object' && data !== null) {
      return Object.values(data).reduce(
        (sum: number, item) => sum + (Array.isArray(item) ? item.length : 0),
        0,
      );
    }
    return 0;
  };

  return (
    <div className="tabs-wrap">
      <div className="tabs">
        {Object.keys(TAB_CONFIG).map((tabId) => {
          const cfg = TAB_CONFIG[tabId];
          const abnormalCount = countAbnormal(tabId);
          return (
            <button
              key={tabId}
              className={`tab ${currentTab === tabId ? 'active' : ''}`}
              onClick={() => switchTab(tabId)}
            >
              {cfg.icon} {tabId}
              {abnormalCount > 0 && <span className="badge">{abnormalCount}</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
